import React from "react";
const socialSites = [
];
const FooterSection = () => (
  <footer className="footer text-center">
    <div className="container">
      <ul className="list-inline mb-5">
      {socialSites.map((site,index)=>(
        <li className="list-inline-item" key={`social_${index}`}>
          <a className="social-link rounded-circle text-white mr-3" href={site.link}>
            <i className={site.icon} />
          </a>
        </li>
      ))}
      </ul>
      <p className="text-muted small mb-0">
        Impressum
        <br></br>
        Inhaber: Artur Rau
        <br></br>
        Anschrift: Schollenäcker 2, 74538 Rosengarten-Uttenhofen
        <br></br>
        Kontakt: <a className="text-dark" href="mailto:info@medizentrum.life">info@medizentrum.life</a> oder unter <a className="text-dark" href="callto://+079149385838">0791/49385838</a>
        <br></br>
        USt-IdNr: DE305515089
        <br></br>
        Copyright &copy; MEDI Zentrum 2018
      </p>
    </div>
  </footer>
);
export default FooterSection;



// WEBPACK FOOTER //
// ./src/main/footer.js